import React from 'react'

import { CbQueryTagTypes } from 'modules/cohort-browser/enums'

import type { PreviewQueryTag, QueryElement } from './preview-query/types'
import { AggregationTag } from './tags/AggregationTag'
import { BracketTag } from './tags/BracketTag'
import { PreviewFilterTag } from './tags/PreviewFilterTag'

const buildQueryComponentFromTag = (queryTag: PreviewQueryTag): JSX.Element | null => {
  switch (queryTag.tagType) {
    case CbQueryTagTypes.Phenotypic:
      return <PreviewFilterTag tag={queryTag} />
    case CbQueryTagTypes.Aggregation:
      return <AggregationTag aggregation={queryTag.aggregationOperation} />
    case CbQueryTagTypes.Bracket:
      return <BracketTag isOpening={queryTag.isOpening} />
    default:
      return null
  }
}

export const convertQueryArrayToElements = (query: PreviewQueryTag[]): QueryElement[] =>
  query.map((queryTag, index) => ({
    key: index.toString(),
    component: buildQueryComponentFromTag(queryTag)
  }))
